module.exports = __webpack_public_path__ + "img/partner-md.feff5657.png";